import { Box, Button, Input } from "@chakra-ui/react";
import { BsDash, BsPlus } from "react-icons/bs";

export function QtyStepper({ value, onChange, min = 0, max }) {
  const canDecrement = value > min;
  const canIncrement = max === undefined || max === null || value < max;

  return (
    <Box
      display="flex"
      alignItems="center"
      bg="rgba(0,74,51,0.06)"
      border="1.5px solid rgba(0,74,51,0.12)"
      borderRadius="999px"
      h="32px"
      px="2px"
      flexShrink={0}
    >
      <Button
        size="sm"
        bg="transparent"
        color="#004a33"
        p="0"
        minW="26px"
        h="26px"
        borderRadius="999px"
        isDisabled={!canDecrement}
        _hover={{ bg: "rgba(0,74,51,0.08)" }}
        onClick={() => canDecrement && onChange(value - 1)}
      >
        <BsDash size={14} />
      </Button>

      <Input
        type="number"
        value={value}
        readOnly
        textAlign="center"
        border="none"
        bg="transparent"
        fontWeight="900"
        fontSize="13px"
        color="#004a33"
        width="34px"
        p="0"
        _focus={{ boxShadow: "none" }}
        cursor="default"
      />

      <Button
        size="sm"
        bg="transparent"
        color="#004a33"
        p="0"
        minW="26px"
        h="26px"
        borderRadius="999px"
        isDisabled={!canIncrement}
        _hover={{ bg: "rgba(0,74,51,0.08)" }}
        onClick={() => canIncrement && onChange(value + 1)}
      >
        <BsPlus size={14} />
      </Button>
    </Box>
  );
}
